module.exports = __webpack_public_path__ + "static/media/bad_website.dd604bb4.png";